import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'redux/rootReducer'
/**
 * Direct selector to the etudierMarche state domain
 */

const selectEtudierMarcheDomain = (state: AppState) => state.etudierMarche

/**
 * Other specific selectors
 */

export const makeSelectLocations = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.locations
)

export const makeSelectTypeBien = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.typeBien
)

export const makeSelectSurfaceTerrainMin = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.surfaceTerrainMin
)

export const makeSelectSurfaceTerrainMax = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.surfaceTerrainMax
)

export const makeSelectSurfaceHabitableMin = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.surfaceHabitableMin
)

export const makeSelectSurfaceHabitableMax = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.surfaceHabitableMax
)

export const makeSelectMontantMin = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.montantMin
)

export const makeSelectMontantMax = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.montantMax
)

export const makeSelectNombrePieces = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.nombrePieces
)

export const makeSelectStartDate = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.startDate
)

export const makeSelectEndDate = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.endDate
)

export const makeSelectDisplayMode = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate.displayMode
)

/**
 * Default selector
 */

const selectEtudierMarche = createSelector(
  selectEtudierMarcheDomain,
  (substate) => substate
)

export default selectEtudierMarche
